import { useRoutes, Navigate } from "react-router-dom";
import Login from "../Components/View/Authentication/Login";
//import CRM from "../Components/View/CRM/CRM";
import React, { Suspense, lazy } from "react";
import Booking from "../Components/View/CRM/OT/Booking";
import CrmCLT from "../Components/View/CRM-Calicut/CrmCLT";
import Treatment from "../Components/View/CRM-Calicut/Treatment";
import Pharmacy from "../Components/View/CRM-Calicut/Pharmacy";
//import Print from "../Components/View/CRM-Calicut/PrintHandler";
import Ccare from "../Components/View/CRM-Calicut/Ccare";
import CustomerForm from "../Components/View/CRM-Calicut/CustomerForm";
import Unauthorized from "../Components/View/CRM/Unauthorized";
import AdminPage from "../Components/View/CRM-Calicut/Pharmacy/AdminPage";
import InventoryForm from "../Components/View/CRM-Calicut/Pharmacy/InventoryForm";
import Suppliers from "../Components/View/CRM-Calicut/Pharmacy/Suppliers";
import StockManagementPage from "../Components/View/CRM-Calicut/Pharmacy/StockManagement";
import InPatient from "../Components/View/CRM-Calicut/Pharmacy/InPatient";
import Purchase from "../Components/View/CRM-Calicut/Pharmacy/Purchase/Purchase";
import Consumption from "../Components/View/CRM-Calicut/Pharmacy/Consumption";
import Reports from "../Components/View/CRM-Calicut/Pharmacy/Reports/Reports";
import SalesInvoices from "../Components/View/CRM-Calicut/Reports/SalesInvoices";
import ProceduresManagement from "../Components/View/CRM-Calicut/Pharmacy/Procedures.js/ProceduresManagement";
import RemovedItems from "../Components/View/CRM-Calicut/Pharmacy/RemovedItems";
import Lab from "../Components/View/CRM-Calicut/Pharmacy/lab/Lab";
import LabManagement from "../Components/View/CRM-Calicut/Pharmacy/lab/LabManagement";
import LabCategory from "../Components/View/CRM-Calicut/Pharmacy/lab/LabCategory";
import LabReportEntry from "../Components/View/CRM-Calicut/Pharmacy/lab/reports/LabReportEntry";
import LabResultsList from "../Components/View/CRM-Calicut/Pharmacy/lab/reports/LabResultsList";
const WholesaleInvoiceList = lazy(
  () => import("../Components/View/CRM/Bills/WholeSaleInvoiceList"),
);
const FeedbackPage = lazy(
  () => import("../Components/View/CRM/Feedback/FeedbackPage"),
);
const BillEntryWT = lazy(
  () => import("../Components/View/CRM/Bills/BillEntryWithoutTax"),
);

const ItemViceView = lazy(
  () => import("../Components/View/CRM-Calicut/Reports/ItemViceView"),
);
const CRMReports = lazy(() => import("../Components/View/CRM/CRMReports"));
const QueueManagement = lazy(
  () => import("../Components/View/QueManagement/QueManagement"),
);
const QueueSystem = lazy(
  () => import("../Components/View/QueManagement/QueueSystem"),
);
const BillEntry = lazy(() => import("../Components/View/CRM/Bills/BillEntry"));
const WholesaleBillEntry = lazy(
  () => import("../Components/View/CRM/Bills/WholeSaleInvoice"),
);
const UserManagement = lazy(
  () => import("../Components/View/Admin/userManagement/UserManagement"),
);

const ManagePurchase = lazy(
  () => import("../Components/View/CRM-Calicut/Accounts/ManagePurchase"),
);
const Admin = lazy(() => import("../Components/View/Admin/Admin"));
const RtnSalesInvoices = lazy(
  () => import("../Components/View/CRM-Calicut/Reports/RtnSalesInvoices"),
);
const PurchaseReturns = lazy(
  () =>
    import("../Components/View/CRM-Calicut/Pharmacy/Purchase/PurchaseReturns"),
);
const BillTabs = lazy(() => import("../Components/View/CRM/Bills/BillingTabs"));
const InvoiceMain = lazy(
  () => import("../Components/View/CRM/Bills/New-Bill/InvoiceMain"),
);
const IDCard = lazy(() => import("../Components/View/Admin/IDCard/IDCard"));
const AdminIDCard = lazy(
  () => import("../Components/View/Admin/IDCard/AdminIDCard"),
);
// const SupportPanel = lazy(() =>
//   import("../Components/View/Support/SupportPanel")
// );
// Wrap the components with the withAuthorization HOC to protect the routes

const ProtectedRoute = ({ element, rights, allowedRights }) => {
  //console.log(rights);
  const tempoToken = sessionStorage.getItem("token");
  // console.log(tempoToken);
  if (tempoToken === "undefined" || tempoToken === null) {
    return <Navigate to="/unauthorized" replace />;
  }

  const hasPermission = allowedRights.some((right) => rights.includes(right));
  return hasPermission ? element : <Navigate to="/unauthorized" replace />;
};
export default function Routing({ userRights, setUserRights }) {
  let elements = useRoutes([
    {
      path: "/",
      element: <Login setUserRights={setUserRights} />,
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },

    {
      path: "trtmnt",
      element: (
        <ProtectedRoute
          element={<Treatment />}
          rights={userRights}
          allowedRights={["Doctor"]}
        />
      ),
    },
    {
      path: "cri-crm",
      element: <Login setUserRights={setUserRights} />,
    },
    {
      path: "crm",
      element: <CrmCLT />,
    },
    {
      path: "ccare",
      element: <Ccare />,
    },

    {
      path: "phmcy",
      element: (
        <ProtectedRoute
          element={<Pharmacy />}
          rights={userRights}
          allowedRights={["Admin", "Reception", "Accounts", "Manager"]}
        />
      ),
    },
    {
      path: "reports",
       element: (
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
            <ProtectedRoute
          element={<CRMReports />}
          rights={userRights}
          allowedRights={["Admin", "Manager", "Reception"]}
        />
            </Suspense>
          ),
     
    },
    {
      path: "invoices",
      element: (
        <ProtectedRoute
          element={<SalesInvoices />}
          rights={userRights}
          allowedRights={["Admin", "Manager", "Reception", "Accounts"]}
        />
      ),
    },
    {
      path: "rtn-invoices",
      element: (
        <ProtectedRoute
          element={
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
              <RtnSalesInvoices />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Manager", "Reception", "Accounts"]}
        />
      ),
    },
    {
      path: "accounts",
      element: (
        <ProtectedRoute
          element={
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
              <ManagePurchase />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Manager", "Reception", "Accounts"]}
        />
      ),
    },
    {
      path: "accounts/items-view",
      element: (
        <Suspense fallback={<div>Component1 is loading, please wait...</div>}>
          <ItemViceView />
        </Suspense>
      ),
    },
    {
      path: "billentry",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <BillEntry />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
    {
      path: "billentry-wt",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <BillEntryWT />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
    {
      path: "wholesale-invoice",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <WholesaleBillEntry />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
    {
      path: "wholesale-invoice-list",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <WholesaleInvoiceList />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
    //wholesale-invoice-list
    {
      path: "otbooking",
      element: (
        <ProtectedRoute
          element={<Booking />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Reception",
            "Doctor",
            "Manager",
            "Accounts",
          ]}
        />
      ),
    },
    {
      path: "customer_form",
      element: (
        <ProtectedRoute
          element={<CustomerForm />}
          rights={userRights}
          allowedRights={["Admin", "Reception", "Customer", "Manager", "Accounts", "Doctor"]}
        />
      ),
    },
    {
      path: "crm-clt",
      element: (
        <ProtectedRoute
          element={<CrmCLT />}
          rights={userRights}
          allowedRights={["Admin", "Reception", "Accounts", "Manager"]}
        />
      ),
    },
    // { path: "sku", element: <StockManagementPage /> },
       {
      path: "sku",
      element: (
        <ProtectedRoute
          element={<StockManagementPage />}
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception","Doctor"]}
        />
      )},
    {
      path: "phmcy-admin",
      element: (
        <ProtectedRoute
          element={<AdminPage />}
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception",]}
        />
      ),
      children: [
        { path: "", element: <StockManagementPage /> },
        { path: "purchase", element: <Purchase /> },
        {
          path: "rtn-purchase",
          element: (
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
              <PurchaseReturns />
            </Suspense>
          ),
        },
        { path: "inventory", element: <InventoryForm /> },
        { path: "suppliers", element: <Suppliers /> },
        { path: "sku", element: <StockManagementPage /> },
        { path: "procedures", element: <ProceduresManagement /> },
        { path: "ip", element: <InPatient /> },
        { path: "consume", element: <Consumption /> },
        { path: "sales", element: <Reports /> },
        { path: "removed-items", element: <RemovedItems /> },
      ],
    },
    {
      //checking pupose to refresh inventory

      path: "phmcy-admin/inventory",
      element: (
        <ProtectedRoute
          element={<AdminPage />}
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
      children: [{ path: "", element: <InventoryForm /> }],
    },
    {
      path: "lab-admin",
      element: (
        <ProtectedRoute
          element={<Lab />}
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "LabAdmin",
            "Doctor",
          ]}
        />
      ),
      children: [
        { path: "", element: <LabCategory /> },
        { path: "lab", element: <LabManagement /> },
        { path: "lab-cat", element: <LabCategory /> },
        { path: "lab-report", element: <LabReportEntry /> },
        { path: "lab-results", element: <LabResultsList /> },
      ],
    },
    {
      path: "admin",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Admin />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "LabAdmin",
          ]}
        />
      ),
      children: [
        {
          path: "",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <UserManagement />
            </Suspense>
          ),
        },
        {
          path: "user-management",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <UserManagement />
            </Suspense>
          ),
        },
        {
          path: "lab-cat",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <LabCategory />
            </Suspense>
          ),
        },
        {
          path: "lab-report",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <LabReportEntry />
            </Suspense>
          ),
        },
        {
          path: "lab-results",
          element: (
            <Suspense fallback={<div>Loading...</div>}>
              <LabResultsList />
            </Suspense>
          ),
        },
      ],
    },
    {
      path: "que-sys", //queue-management"
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <QueueSystem />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "LabAdmin",
          ]}
        />
      ),
    },
    {
      path: "queue-management", //queue-management"
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <QueueManagement />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "LabAdmin",
          ]}
        />
      ),
    },
    {
      path: "bill-tabs", //queue-management"
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <BillTabs />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "LabAdmin",
          ]}
        />
      ),
    },
    {
      path: "feedback",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <FeedbackPage />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "Customer",
            "Doctor",
          ]}
        />
      ),
    },
    {
      path: "new-invoice",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <InvoiceMain />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
    {
  path: "id-card",
  element: (
    <ProtectedRoute
      element={
        <Suspense fallback={<div>Loading ID Card...</div>}>
          <IDCard />
        </Suspense>
      }
      rights={userRights}
      allowedRights={[
        "Admin",
        "SuperAdmin",
        "HR",
        "HR Executive",
        "Recruiter",
        "Chairman",
        "Principal",
        "Accounts",
      ]}
    />
  ),
},
{
  path: "admin-id-card",
  element: (
    <ProtectedRoute
      element={
        <Suspense fallback={<div>Loading Admin ID Card...</div>}>
          <AdminIDCard />
        </Suspense>
      }
      rights={userRights}
      allowedRights={["Admin", "SuperAdmin"]}
    />
  ),
},
    // {
    //   path: "support",
    //   element: (
    //     <ProtectedRoute
    //       element={
    //         <Suspense fallback={<div>Loading...</div>}>
    //           <SupportPanel />
    //         </Suspense>
    //       }
    //       rights={userRights}
    //       allowedRights={["Admin"]}
    //     />
    //   ),
    //  },
  ]);

  return elements;
}
